import { Metadata, descriptorOf } from '@tencent/workbench-core';
import { DynamicLoaderRegistry } from '../classes/dynamic-loader.js';
import { InjectorService } from '../classes/injector-service.js';

/**
 * 一个加载器注入装饰器，用于专门注入一个加载器
 *
 * @param symbol - Provider 的 key
 * @public
 */
function Loader(symbol) {
    const key = Symbol.for(`loader:${symbol.toString()}`);
    const loader = DynamicLoaderRegistry.createIfNotExists(symbol);
    if (!InjectorService.has(key)) {
        InjectorService.factory(key, loader);
    }
    return function (target, targetKey, descriptor) {
        if (typeof descriptor === 'number') {
            const paramTypes = Metadata.getParamTypes(target, targetKey);
            paramTypes[descriptor] = key;
            Metadata.setParamTypes(target, targetKey, paramTypes);
        }
        else {
            if (descriptor === undefined) {
                descriptor = descriptorOf(target, targetKey);
            }
            if (descriptor === undefined) {
                // 对类的成员进行注入
                Metadata.setType(target, targetKey, key);
                return {
                    get: () => InjectorService.invokeGetter(target, targetKey),
                };
            }
            return descriptor;
        }
    };
}
/**
 * 获取loader的方法
 * @param symbol - 注册loader的 key
 * @public
 */
function getLoader(symbol) {
    const key = Symbol.for(`loader:${symbol.toString()}`);
    const loader = DynamicLoaderRegistry.createIfNotExists(symbol);
    if (!InjectorService.has(key)) {
        InjectorService.factory(key, loader);
    }
    return InjectorService.get(key);
}

export { Loader, getLoader };
//# sourceMappingURL=loader.js.map
